import productsFieldsQuery from '../domain/types/graphql/fields/products'
import { gql } from './gql'

/**
 * Search across the whole catalog, not across the page the grid happens to hold.
 *
 * cinnamon ports `searchProduct`, which returns a bare `[Product]` and has no
 * pagination — a search for "co" on a large storefront answers with everything
 * and the client throws most of it away. `search` is the same resolver behind a
 * `{ products, pagination }` wrapper, so a result set can be walked a page at a
 * time by the same control that walks the catalog.
 *
 * `filter` is the reason this doubles as the browse query: `SearchFilterInput`
 * carries `categories`, `brands`, `attributes` and `promotions`, so the chips,
 * the filter sheet and the text box are one request rather than three views the
 * client has to intersect itself. An empty `searchTerm` is a browse with
 * filters and no text — which is exactly what selecting a brand should do.
 */
export const SEARCH_PRODUCTS = gql`
  query SearchProducts(
    $storefrontName: String!
    $sessionUid: String!
    $searchTerm: String
    $filter: SearchFilterInput
    $pagination: PaginationInput
  ) {
    search(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      searchTerm: $searchTerm
      filter: $filter
      pagination: $pagination
    ) {
      products {
        ${productsFieldsQuery}
      }
      pagination {
        total
        totalPages
        pageNumber
        pageSize
        hasNextPage
      }
    }
  }
`
